import { withInstall } from '@zoryn/utils'
import Col from './src/col.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCol: SFCWithInstall<typeof Col> = withInstall(Col)
export default ZCol

export * from './src/col'
